import React, { useState } from "react";
import "./bonusSignup.css"; // Ensure this points to your new CSS file
import { IoIosInformationCircleOutline } from "react-icons/io";
import { MdLock } from "react-icons/md";

import DepositRule from "./DepositRule";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Popvip from "./Popvip";
import BonusDetails from "./BonusDetails";

const BonusSignup = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const [showBonusdetails, setshowBonusdetails] = useState(false);

  // Toggle the popup visibility
  const toggleBonusDetails = () => {
    setshowBonusdetails(!showBonusdetails);
  };

  const generateSchedule = () => {
    const daysInMonth = 31;
    const schedule = [];
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    for (let date = 1; date <= daysInMonth; date++) {
      const dayIndex = new Date(2023, 11, date).getDay();
      schedule.push({
        day: dayNames[dayIndex],
        date,
        month: "December",
        bonus: "No Bonus",
      });
    }
    return schedule;
  };

  const schedule = generateSchedule();
  const today = new Date();
  const todayDate = today.getDate();

  const bonusBox = [
    {
      img: <img src="assets/bcimages/bonus/bonusbox1.webp" />,
      title: "Quests",
      details1: "Daily Quests:",
      details2: "0/3",
      details3: "Weekly Quests:",
      details4: "0/1",
      buttonText: "Claim",
    },
    {
      img: <img src="assets/bcimages/bonus/bonusbox2.webp" />,
      title: "Lucky Spin",
      details1: "VIP Spin:",
      details2: "Reach VIP 1",
      details3: "Daily Spin:",
      details4: "₹0.00/₹17,105.12",
      buttonText: "Claim",
    },
    {
      img: <img src="assets/bcimages/bonus/bonusbox3.webp" />,
      title: "Roll Competition",
      details1: "Total claimed:",
      details2: "₹0.00",
      details3: "",
      details4: "",
      buttonText: "Claim",
    },
    {
      img: <img src="assets/bcimages/bonus/bonusbox4.webp" />,
      title: "BCD Rakeback",
      details1: "Locked BCD:",
      details2: "0 BCD",
      details3: "Ready to claim:",
      details4: "0 BCD",
      buttonText: "Claim",
    },
    {
      img: <img src="assets/bcimages/bonus/bonusbox5.webp" />,
      title: "Vault Pro",
      details1: "My Holdings:",
      details2: "₹0.00",
      details3: "Total Return:",
      details4: "₹0.00",
      buttonText: "Transfer In",
    },
  ];
  const color = [
    "radial-gradient(116.81% 83.5% at 46.23% 9.2%, #493983 0%, #323738 60%)",
    "radial-gradient(116.81% 83.5% at 46.23% 9.2%, #715322 0%, #323738 60%)",
    "radial-gradient(116.81% 83.5% at 46.23% 9.2%, #5E7123 0%, #323738 60%)",
    "radial-gradient(116.81% 83.5% at 46.23% 9.2%, #6F5324 0%, #323738 60%)",
    "radial-gradient(116.81% 83.5% at 46.23% 9.2%, #663334 0%, #323738 60%)",
  ];

  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupContent, setPopupContent] = useState("");

  const handleIconClick = (title) => {
    let content = "";
    if (title === "Lucky Spin") {
      content = (
        <div className="bonus-luckyspin">
          <div className="bonus-luckyspinRule game-fonts">Lucky Spin Rules</div>
          <div className="bonus-luckyspinList game-fonts">
            <ul>
              <li>
                You will receive 1 free spin every day once you reach a specific
                wager amount
              </li>
              <li>
                Starting from VIP level 8, you will receive one free spin each
                time you level up, and there is no limit to the number of spins
                you can earn.
              </li>
            </ul>
          </div>
        </div>
      );
    } else if (title === "Roll Competition") {
      content = `Each player has one chance to roll every 24 hours.
Prizes are drawn at 2:10 (UTC+0) every day.
The points of ROLL are from 0-999, 0 is the smallest, and 999 is the largest. Every day we will list the top 10 players in descending order from largest to smallest for rewards.
If the same points are rolled by different players at the same time, the ranking will be determined by time.`; // Add specific content here
    } else if (title === "BCD Rakeback") {
      content = (
        <div>
          <div className="rakeback-popup">
            <div>Rakeback Rules</div>
            <div className="rakeback-header">
              <div className="rakeback-img">
                <img
                  src="assets/bcimages/bonus/bonus-rekeback.png"
                  alt="BCD Icon"
                />
              </div>
              {/* <a href="/contract" target="_blank" rel="noopener noreferrer">View Contract</a> */}
            </div>
            <div className="rakeback-details">
              <button>How to unlock BCD?</button>
              <button>How to claim BCD?</button>
              <button>Can BCD be exchanged to any other currency?</button>
              <button>What is special about BCD?</button>
            </div>
          </div>
        </div>
      ); // Add specific content here
    }

    setPopupContent(content);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
    setPopupContent("");
  };

  return (
    <div>
      <section>
        <div className="bonusSing_container">
          <div className="bSignup_redeem">
            <div className="b-heading">Bonus</div>
            <div className="b-input">
              <input
                type="text"
                placeholder="Redeem your bonus here."
                id="b-input"
              />
              <div className="redeem">Redeem Code</div>
            </div>
          </div>
          <div className="bsignup_banner">
            <div className="bSing-banner1">
              <div className="bonus-blur">
                <div className="INR">Total Bonus Claimed (INR)</div>
                <div className="bonus-rupees">₹ 0.00</div>
                <div className="totalBonus">
                  <div className="totalbonus-content">
                    <div className="total-h">Total VIP Bonus</div>
                    <div className="total-p">₹ 0.00</div>
                  </div>
                  <div className="totalbonus-content">
                    <div className="total-h">Total Special Bonus</div>
                    <div className="total-p">₹ 0.00</div>
                  </div>
                  <div className="totalbonus-content">
                    <div className="total-h">Total General Bonus</div>
                    <div className="total-p">₹ 0.00</div>
                  </div>
                </div>
              </div>
              <div className="bonus-detail" onClick={toggleBonusDetails}>
                Details
              </div>
              <img
                src="assets/bcimages/bonus/bannerSignup.png"
                alt="Bonus Banner"
              />
            </div>

            <div id="bonus-singbanner">
              <div className="deposit-cosino">
                <div className="deposit-heading">
                  <div className="deposit-casino-h">Deposit Bonus</div>
                  <div className="deposit-casino-p">Get up to: 500 BCD</div>
                </div>
                <div className="deposit-icon" onClick={togglePopup}>
                  <IoIosInformationCircleOutline />
                  <DepositRule
                    showPopup={showPopup}
                    togglePopup={togglePopup}
                  />
                </div>
              </div>
              <div className="bonus-line">
                <div className="bonus-line-img">
                  <div className="bonus-l-img1">
                    <img src="assets/bcimages/bonus/coin1.webp" alt="Coin 1" />
                  </div>
                  <div className="bonus-l-img1">
                    <img src="assets/bcimages/bonus/coin2.webp" alt="Coin 2" />
                  </div>
                  <div className="bonus-l-img1">
                    <img src="assets/bcimages/bonus/coin3.webp" alt="Coin 3" />
                  </div>
                  <div className="bonus-l-img1">
                    <img src="assets/bcimages/bonus/coin4.webp" alt="Coin 4" />
                  </div>
                </div>
                <div className="progress1">
                  <div className="progress-barr"></div>
                </div>
                <div className="bonus-line-no">
                  <div className="bonus-no">+180%</div>
                  <div className="bonus-no">+240%</div>
                  <div className="bonus-no">+300%</div>
                  <div className="bonus-no">+360%</div>
                </div>
              </div>
              <div className="bonus-end">
                <div className="bonus-banner-end">
                  Bonus ends: <div className="b-e-time">04d 16h 26m</div>
                </div>
                <div className="bonus-line-deposit">
                  <a href="#">
                    <button className="bonus-line-deposit-btn">
                      Deposit Now
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BonusDetails
          showBonusdetails={showBonusdetails}
          toggleBonusDetails={toggleBonusDetails}
        />
      </section>

      {/* General Bonus */}
      <section>
        <div className="general-bonus">
          <div className="general-h">General Bonus</div>
          <div className="general">
            <div className="bcBank">
              <div className="bcbank-img">
                <img src="assets/bcimages/bonus/general-bonus-bank.webp" />
              </div>
              <div className="bcbank-content">
                <div className="back-h">
                  bank
                  <Tooltip
                    title="Bc Bank will be able to claim every 8 hour. Claim 3 time/day, expire in 24 hour"
                    placement="top"
                  >
                    <IconButton>
                      <IoIosInformationCircleOutline
                        style={{ color: "#849194" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
                <div className="back-p">
                  <div className="bank-total-p">Total bonus in bank</div>
                  <div className="bank-total-p1">₹0.00</div>
                </div>
                <div className="bank-claim">
                  <div className="claim-h">₹0.00</div>
                  <div className="claim-p">Claim</div>
                </div>
                <div className="bank-f">Claim every 8 hours</div>
                <div className="bank-icon-content">
                  Bc Bank will be able to claim every 8 hour. Claim 3 time/day,
                  expire in 24 hour
                </div>
              </div>
            </div>
            <div className="bank-schedule">
              <div className="schedule-container">
                <div className="schedule-header">Bank Schedule</div>
                <div className="schedule-scroll-container">
                  {schedule.map((item, index) => (
                    <div className="schedule-item" key={index}>
                      <div
                        className={`schedule-date ${
                          item.date === todayDate ? "today" : ""
                        }`}
                      >
                        <div className="schedule-date-number">{item.date}</div>
                        <div>{item.day}</div>
                      </div>
                      <div>
                        <div>{item.month}</div>
                      </div>
                      <div className="schedule-bonus">{item.bonus}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="bonus-box">
            {bonusBox.map((card, index) => (
              <div
                key={index}
                className="bonus-card"
                style={{ backgroundImage: color[index % color.length] }}
              >
                <div className="boximg">
                  {card.img}
                  {["Lucky Spin", "Roll Competition", "BCD Rakeback"].includes(
                    card.title
                  ) && (
                    <IoIosInformationCircleOutline
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        fontSize: "25px",
                        fontWeight: "600",
                        color: "#9c9e9f",
                      }}
                      onClick={() => handleIconClick(card.title)}
                    />
                  )}
                </div>
                <div className="boxtitle">{card.title}</div>
                <div className="boxdetail">
                  <div className="boxdetail-content">
                    <div className="box-detail">
                      <div className="b-detail-h">{card.details1}</div>
                      <div className="b-detail">{card.details2}</div>
                    </div>
                    <div className="box-detail">
                      <div className="b-detail-h">{card.details3}</div>
                      <div className="b-detail">{card.details4}</div>
                    </div>
                  </div>
                  <div className="boxbutton">{card.buttonText}</div>
                </div>
              </div>
            ))}

            {isPopupVisible && (
              <div className="popup">
                <div className="popup-content">
                  <div className="close" onClick={closePopup}>
                    &times;
                  </div>
                  <p>{popupContent}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <section>
        <div className="vipBonus">
          <div className="vipBonus-heading">VIP Bonus</div>
          <div className="vipBonus-container">
            <div className="vip-bonus">
              <div className="vip-levelup">
                <Popvip />
              </div>
              <div className="vipbonus-progress">
                <div className="vipbonus-img">
                  <img src="assets/bcimages/bonus/vip.webp" />
                </div>
                <div className="vipbonus-content">
                  <div className="vipbonus-h">VIP 0</div>
                  <div className="vipbonus-p1">
                    <div className="v-progress">Your VIP Progress</div>
                    <div className="v-progress">
                      0.0%{" "}
                      <IoIosInformationCircleOutline
                        style={{ fontSize: "1.3rem" }}
                      />
                    </div>
                  </div>
                  <div className="vipbonus-progress-bar"></div>
                </div>
              </div>
              <div className="vipbonus-claim">
                <div className="vip-claim">
                  <div className="v-claim">Total VIP Bonus Claimed</div>
                  <div className="v-claim">₹0.00 </div>
                </div>
                <div className="vip22">Available at VIP 22</div>
              </div>
            </div>
            <div className="vip-box" id="vip-box-hide">
              <div className="vip-box-img">
                <img src="assets/bcimages/bonus/vipBox1.webp" />
              </div>
              <div className="vip-box-head">Recharge</div>
              <div className="vip-box-f">
                <div className="vip-box-f-h">
                  <MdLock className="lock" /> Available at VIP 22
                </div>
                <div className="vip-box-f-p">
                  Ends in <span className="vip-highlight">03d 15h 24m</span>
                </div>
              </div>
            </div>
          </div>

          <div className="vipBonus-box" id="vipbonus-box">
            <div className="vip-box" id="vip-box-visible">
              <div className="vip-box-img">
                <img src="assets/bcimages/bonus/vipBox1.webp" />
              </div>
              <div className="vip-box-head">Recharge</div>
              <div className="vip-box-f">
                <div className="vip-box-f-h">
                  <MdLock className="lock" /> Available at VIP 22
                </div>
                <div className="vip-box-f-p">
                  Ends in <span className="vip-highlight">03d 15h 24m</span>
                </div>
              </div>
              <IoIosInformationCircleOutline className="info-icon" />
            </div>
            <div className="vip-box" id="vip-box-sky">
              <div className="vip-box-img">
                <img src="assets/bcimages/bonus/vipBox2.webp" />
              </div>
              <div className="vip-box-head">Weekly Cashback</div>
              <div className="vip-box-f">
                <div className="vip-box-f-h">
                  <MdLock className="lock" /> Available at VIP 22
                </div>
                <div className="vip-box-f-p">
                  Ends in <span className="vip-highlight">03d 15h 24m</span>
                </div>
              </div>
              <IoIosInformationCircleOutline className="info-icon" />
            </div>
            <div className="vip-box" id="vip-box-red">
              <div className="vip-box-img">
                <img src="assets/bcimages/bonus/vipBox3.webp" />
              </div>
              <div className="vip-box-head">Monthly Cashback</div>
              <div className="vip-box-f">
                <div className="vip-box-f-h">
                  <MdLock className="lock" /> Available at VIP 22
                </div>
                <div className="vip-box-f-p">
                  Ends in <span className="vip-highlight">03d 15h 24m</span>
                </div>
              </div>
              <IoIosInformationCircleOutline className="info-icon" />
            </div>
            <div className="vip-box" id="vip-box-blue">
              <div className="vip-box-img">
                <img src="assets/bcimages/bonus/vipBox4.webp" />
              </div>
              <div className="vip-box-head">Sports Weekly Bonus</div>
              <div className="vip-box-f">
                <div className="vip-box-f-h">
                  <MdLock className="lock" /> Available at VIP 22
                </div>
                <div className="vip-box-f-p">
                  Ends in <span className="vip-highlight">03d 15h 24m</span>
                </div>
              </div>
              <IoIosInformationCircleOutline className="info-icon" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BonusSignup;
